<template>
  <div class="form">
    <div class="field m-b-15">
      <label class="label">Pitch By</label>
      <div class="control">
        <multiselect
          v-model="playlist.pitch_by_user"
          :options="users"
          track-by="id"
          label="full_name"
          :value="playlist.pitch_by_user"
          :close-on-select="true"
        ></multiselect>
      </div>
    </div>
    <div class="field m-b-15">
      <div class="level m-b-0">
        <div class="level-left">
          <label class="label">Pitch To</label>
        </div>
        <div class="level-right">
          <div>
            <a
              class="is-primary tooltip is-tooltip-left"
              data-tooltip="Create Contact"
              @click="addContact"
              v-if="$can.includes('create-contacts')"
            >
              <IconPlus style="height: 20px; width: 20px;"/>
            </a>
          </div>
        </div>
      </div>
      <div class="control">
        <multiselect
        v-model="playlist.pitch_to_contact"
        :options="contacts"
        track-by="id"
        label="name"
        :close-on-select="true"
        >
        </multiselect>
      </div>
    </div>
      <div class="field m-b-15">
        <label class="label">Pitching For</label>
        <div class="control">
          <multiselect
          v-model="playlist.pitch_artists"
          :multiple="true"
          :taggable="true"
          @tag="addArtist"
          tag-placeholder="Artist not found. Press enter to create"
          :options="artists"
          track-by="id"
          label="name"
          :close-on-select="true"
          >
          </multiselect>
        </div>
      </div>
      <div class="field m-b-15">
    <label class="label">What would you like to create (Avery&trade; 5694/5698 template)?</label>
      <div class="control">
        <label class="radio tooltip-span-label">
          <input type="radio" class="m-r-5" name="cdLabel" v-model="playlist.cdLabel" value="top" required>
          Only Top CD Sticker
        </label>
        <label class="radio tooltip-span-label">
          <input type="radio" class="m-r-5" name="cdLabel" v-model="playlist.cdLabel" value="bottom">
          Only Bottom CD Sticker
        </label>
        <label class="radio tooltip-span-label">
          <input type="radio" class="m-r-5" name="cdLabel" v-model="playlist.cdLabel" value="entire">
          Use Entire Sheet
        </label>
      </div>
    </div>
    <form-modal
      type="contact"
      title="Add Contact"
      :model="contact"
      :isModal="isModal"
      v-on:clear-modal="clearModal"
      v-on:save-record="saveContact"
    ></form-modal>
    </div>
</template>

<script>

import Multiselect from 'vue-multiselect'
import { IconPlus } from '@/Icons/IconBase'

import {
  ALL_FOR_FORM,
  CONTACT_ALL_FOR_FORM,
  USER_ALL,
  CREATE,
  CONTACT_CREATE
} from '@/store/actions'

export default {
  name: 'PlaylistCdLabelForm',
  model: {
    prop: 'playlist',
    event: 'change'
  },
  components: {
    Multiselect,
    IconPlus
  },
  data() {
    return {
      isModal: false,
      contact: {}
    }
  },
  props: {
    playlist: Object,
    isSaving: Boolean
  },
  created: function () {
    this.$store.dispatch(ALL_FOR_FORM, 'artist')
    this.$store.dispatch(CONTACT_ALL_FOR_FORM)
    this.$store.dispatch(USER_ALL)
  },
  computed: {
    artists() {
      return this.$store.state.artist.artists
    },
    contacts() {
      return this.$store.state.contact.contacts
    },
    users() {
      return this.$store.state.user.users
    }
  },
  mounted() {
    if (this.playlist.pitch_for_artist_ids) {
      let selectedArtists = this.artists.filter(artist => this.playlist.pitch_for_artist_ids.indexOf(artist.id) !== -1)
      this.$set(this.playlist, 'pitch_artists', selectedArtists)
    }
    if (this.playlist.pitch_to_contact_id) {
      let selectedContact = this.contacts.find(contact => contact.id === this.playlist.pitch_to_contact_id)
      this.$set(this.playlist, 'pitch_to_contact', selectedContact)
    }
  },
  methods: {
    addArtist(newArtist) {
      let self = this
      this.$store.dispatch(CREATE, {
        resourceName: 'artist',
        data: { name: newArtist }
      })
        .then(resp => {
          if (self.playlist.pitch_artists) {
            let index = self.playlist.pitch_artists.length
            self.$set(self.playlist.pitch_artists, index, resp)
          } else {
            self.$set(self.playlist, 'pitch_artists', [])
            self.playlist.pitch_artists.push(resp)
          }
        })
    },
    addContact() {
      this.clearModal()
      this.isModal = !this.isModal
    },
    saveContact(data) {
      let self = this
      this.$store.dispatch(CONTACT_CREATE, data)
        .then(function (contact) {
          self.clearModal()
          self.playlist.pitch_to_contact = contact
        }, function (err) {
          self.clearModal()
          alert(err)
        })
    },

    clearModal() {
      this.contact = {}
      this.isModal = false
    }
  }
}
</script>
